module.exports = __webpack_public_path__ + "static/img/dragonVR.f90ace48.svg";